import { render, staticRenderFns } from "./AdminCustomers.vue?vue&type=template&id=7cb72d63&scoped=true&"
import script from "./AdminCustomers.vue?vue&type=script&lang=js&"
export * from "./AdminCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb72d63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cb72d63')) {
      api.createRecord('7cb72d63', component.options)
    } else {
      api.reload('7cb72d63', component.options)
    }
    module.hot.accept("./AdminCustomers.vue?vue&type=template&id=7cb72d63&scoped=true&", function () {
      api.rerender('7cb72d63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/AdminPage/AdminCustomers.vue"
export default component.exports